module.exports = __webpack_public_path__ + "img/inco2Ac.97d1df21.png";